import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { classNames } from 'primereact/utils';

const MessageWrap = styled.div`

`;

/**
 * A customizable information message box
 */
const InfoMessageTemplate = ({ message = null, type, className, innerHtml = null}) => {
    const [cssClasses, setCssClasses] = useState('info-message p-message p-component p-message-' + (type || 'info') + ' p-message-enter-done');

    useEffect(() => {
        if (className) {
            setCssClasses(cssClasses + ' ' + className);
        }
    }, []);

    return (
        <MessageWrap>
            <div className={cssClasses}>
                <div className="p-message-wrapper">
                    <span className="p-message-icon pi pi-info-circle"></span>
                    {message === null && <span className="p-message-detail" dangerouslySetInnerHTML={{__html: innerHtml}}></span>}
                    {message && <span className="p-message-detail">{message}</span>}
                </div>
            </div>
        </MessageWrap>

    );
};

export default InfoMessageTemplate;
